import {
    lazy,
    Suspense,
    useMemo,
} from 'react';

import { ToastContainer } from 'react-toastify';
import {
    Helmet,
    HelmetProvider,
} from 'react-helmet-async';

import {
    Home,
    Layout,
    Allocations,
} from 'components/sections';
import Modal from 'components/Modal';
import { useInit } from 'hooks';
import { currentEnv } from 'configs';

import GlobalStyles from './GlobalStyles';

const PrivateSale = lazy(() => import('components/sections/PrivateSale'));

const App = () => {
    // TODO: Combine all memos into one single memo
    const saleData = useMemo(() => ({
        PRIVATE_SALE_1: {
            subtitle: 'PRIVATE SALE PHASE 1',
            rate: 5,
            welcomeText: 'Welcome to FTN token sale round 1.',
        },
        PRIVATE_SALE_2: {
            subtitle: 'PRIVATE SALE PHASE 2',
            rate: 4,
            welcomeText: 'Welcome to FTN token sale round 2.',
        },
        ADVISORS: {
            subtitle: 'FTN REWARDS',
            welcomeText: 'Welcome to the FTN Rewards for SoftConstruct employees.',
            connectionWarning: 'NOTE: This wallet address will also be used to claim your FTN tokens in the future, DO NOT LOSE IT!',
        },
    }), []);
    const currentPhaseData = useMemo(() => saleData[currentEnv.name] || {}, [saleData]);

    useInit();

    return (
        <HelmetProvider>
            <Helmet>
                <title>
                    {currentEnv.siteTitle}
                </title>
            </Helmet>

            <div className="App">
                <ToastContainer
                    className="ftn-toast"
                    hideProgressBar
                />
                <Modal />
                <GlobalStyles />
                <Layout>
                    <Suspense fallback={<></>}>
                        {currentEnv.name === 'ALLOCATIONS' && <Allocations />}
                        {(['PRIVATE_SALE_1', 'PRIVATE_SALE_2', 'ADVISORS'].includes(currentEnv.name)) && <PrivateSale data={currentPhaseData} />}
                        {currentEnv.name === 'CLAIM' && <Home />}
                    </Suspense>
                </Layout>
            </div>
        </HelmetProvider>
    );
};

export default App;
